import { render, staticRenderFns } from "./DomainsTab.vue?vue&type=template&id=3127e712"
import script from "./DomainsTab.vue?vue&type=script&lang=js"
export * from "./DomainsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports